import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { WorkflowEditor } from "@/components/admin/WorkflowEditor";
import { safeUUID } from "@/lib/utils";

export default function WorkflowEditorPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Allow 'new' for creating workflows, but validate UUIDs
    if (id && id !== 'new' && !safeUUID(id)) {
      console.error(`Invalid workflow ID: "${id}"`);
      navigate('/admin/templates/workflows');
    }
  }, [id, navigate]);
  
  return <WorkflowEditor workflowId={id === 'new' ? undefined : id} />;
}